import React, { Component } from 'react'

class Card extends Component {
  render() {
    const { title, date, thumbnail, children } = this.props;

    return (
      <div className='card'>
        {thumbnail &&
          <div className="card__image">
            <img src={thumbnail} alt={title} />
          </div>
        }
        <div className="card__content">
          <h3>{title}</h3>
          <p className='card__date'>{date}</p>
          {children}
        </div>
      </div>
    );
  }
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card/index.js